export default __webpack_public_path__ + "static/fred-1b3055813335104644bd3365235f5d42.png";